module.exports = __webpack_public_path__ + "img/sign_mockup.b8b77852.jpg";